import { Icon } from '@iconify/react';
import { Box, Drawer, IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import { GetAssignmentRes } from '../../types/assignments';
import VehicleCompare from '../VehicleCompare';

interface Props {
  open: boolean;
  onClose: () => void;
  data: GetAssignmentRes;
}

const PreviewDrawer: React.FC<Props> = ({ data, onClose, open }) => {
  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Stack sx={{ padding: (theme) => theme.spacing(3, 4) }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <Typography variant="h5" fontSize="24px">
              {data.requestNumber}
            </Typography>
          </Box>
          <IconButton onClick={onClose}>
            <Icon icon="akar-icons:cross" />
          </IconButton>
        </Box>
        <Box my={1}>
          {data.comments && (
            <Stack sx={{ bgcolor: '#f2f2f2', p: 1, borderRadius: 1 }}>
              <Typography variant="caption" sx={{ fontSize: 10, color: (theme) => theme.palette.grey[600] }}>
                Reason for request
              </Typography>
              <Typography variant="caption">{data.comments}</Typography>
            </Stack>
          )}
        </Box>
        <Box>
          <VehicleCompare inventoryVehicle={data.inventoryVehicle} customerVehicle={data.customerVehicle} />
        </Box>
      </Stack>
    </Drawer>
  );
};

export default PreviewDrawer;
